



import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom'; // استيراد useNavigate للتوجيه

function HomePage() {
  const [events, setEvents] = useState([]);
  const [user, setUser] = useState(null); // حالة المستخدم
  const [venueQuery, setVenueQuery] = useState('');
  const [dateQuery, setDateQuery] = useState(''); // حالة لتخزين تاريخ البحث
  const navigate = useNavigate(); // للتعامل مع التوجيه

  useEffect(() => {
    fetchAllEvents();
    // فحص حالة تسجيل الدخول عند تحميل الصفحة
    const token = localStorage.getItem('token');
    if (token) {
      // يمكنك هنا جلب معلومات المستخدم إذا لزم الأمر وتحديث حالة المستخدم
      setUser({ token }); // مثال بسيط بتخزين التوكن كدليل على تسجيل الدخول
    }
  }, []);

  const fetchAllEvents = () => {

    //https://localhost:7136/api/event
    axios.get('https://localhost:7136/api/event')
      .then((response) => {
        setEvents(response.data);
      })
      .catch((error) => {
        console.error("There was an error fetching the events!", error);
      });
  };

  const handleSearchByVenue = () => {
    if (!venueQuery.trim()) {
      fetchAllEvents();
      return;
    }
//https://localhost:7136/api/event/get-${venueQuery}
    axios.get(`https://localhost:7136/api/event/get-${venueQuery}`)
      .then((response) => {
        setEvents(response.data);
      })
      .catch((error) => {
        console.error("Error fetching events by venue:", error);
        setEvents([]);
      });
  };

  const handleSearchByDate = () => {
    if (!dateQuery) {
      fetchAllEvents();
      return;
    }

    // يتم إرسال تاريخ حقل الإدخال افتراضيًا بتنسيق YYYY-MM-DD وهو متوافق مع :datetime في مسار API .NET
    //https://localhost:7136/api/event/date/${dateQuery}
    axios.get(`https://localhost:7136/api/event/date/${dateQuery}`)
      .then((response) => {
        setEvents(response.data);
      })
      .catch((error) => {
        console.error("Error fetching events by date:", error);
        setEvents([]);
      });
  };

  const handleDownload = async (fileName) => {
    try {
      const response = await axios.get(`https://localhost:7136/api/event/download/${fileName}`, {
        responseType: 'blob',
      });

      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('خطأ أثناء التحميل:', error);
    }
  };

  const handleBookTicket = (eventId) => {
    if (user) {
      // المستخدم مسجل الدخول، قم بتوجيهه إلى صفحة الحجز مع معرف الفعالية
      navigate(`/participant`); // افترض أن لديك صفحة حجز بهذا المسار
    } else {
      alert(`سجل دخول اولا `);

      // المستخدم غير مسجل الدخول، قم بتوجيهه إلى صفحة تسجيل الدخول
      navigate('/login');
    }
  };

  return (
    <div className="min-h-screen bg-cover bg-center flex flex-col items-center justify-start p-4"
      style={{ backgroundImage: `url('./images/photo3.jpg')` }}>

      {/* الجزء العلوي */}
      <div className="w-full flex flex-col items-center justify-center py-10 space-y-4">
        <h1 className="text-5xl text-white font-extrabold shadow-lg transform transition-all duration-300 hover:scale-110 font-custom">
          الفعاليات المتاحة
        </h1>

        {/* روابط تسجيل الدخول والتسجيل */}
        <div className="text-white">
        
            <div>
              <Link to="/login" className="mx-4 text-3xl font-extrabold text-white hover:text-purple-500 transition duration-300 font-custom">تسجيل الدخول</Link>
              <Link to="/register" className="mx-4 text-3xl font-extrabold text-white hover:text-purple-500 transition duration-300 font-custom">إنشاء حساب</Link>
            </div>
      
        </div>

        {/* البحث */}
        <div className="mt-4 flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-2 rtl:space-x-reverse">
          <input
            type="text"
            value={venueQuery}
            onChange={(e) => setVenueQuery(e.target.value)}
            placeholder="ابحث باسم المكان"
            className="px-4 py-2 rounded-lg shadow-md focus:outline-none"
          />
          <button
            onClick={handleSearchByVenue}
            className="bg-purple-600 hover:bg-purple-700 text-white font-bold py-2 px-4 rounded-lg transition"
          >
            بحث بالاسم
          </button>

          <input
            type="date"
            value={dateQuery}
            onChange={(e) => setDateQuery(e.target.value)}
            className="px-4 py-2 rounded-lg shadow-md focus:outline-none"
          />
          <button
            onClick={handleSearchByDate}
            className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded-lg transition"
          >
            بحث بالتاريخ
          </button>
        </div>
      </div>

      {/* عرض الفعاليات */}

      <div className="w-full max-w-screen-lg">
        {events.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">



          
            {events.map((event) => {

              const mediaUrl = `https://localhost:7136/Uploads/${event.mediaFileName}`;
              const isVideo = event.mediaFileName?.match(/\.(mp4|mov|avi|webm)$/i);
              return (
                <div
                  key={event.eventId}
                  className="bg-white p-6 rounded-lg shadow-xl transition-all hover:shadow-2xl hover:scale-105 cursor-pointer flex flex-col justify-between" // تم إضافة فئات التحويل هنا
                >
                  <div>
                    {isVideo ? (
                      <div className="relative w-full rounded-md overflow-hidden mb-4 aspect-video">
                        <video controls className="absolute top-0 left-0 w-full h-full object-cover rounded-md">
                          <source src={mediaUrl} type="video/mp4" />
                          متصفحك لا يدعم تشغيل الفيديو.
                        </video>
                      </div>
                    ) : (
                      <img
                        src={mediaUrl}
                        alt="Event Media"
                        className="w-full h-40 object-cover rounded-md mb-4 cursor-pointer"
                      />
                    )}

                    {/* زر التحميل */}
                    <button
                      onClick={() => handleDownload(event.mediaFileName)}
                      className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-1 px-4 rounded mb-3 transition"
                    >
                      تحميل الوسائط
                    </button>

                    <h3 className="text-2xl font-bold text-gray-800 mb-2 font-custom">{event.title}</h3>
                    <p className="text-gray-600 mb-2 font-custom">{event.description}</p>
                    <p className="text-gray-800 font-custom">Organizer Name: {event.organizerName}</p>
                    <p className="text-gray-800 font-custom">Venue: {event.venue}</p>
                    <p className="text-gray-800 font-custom">Event Date: {new Date(event.eventDatetime).toLocaleDateString()}</p>
                    <p className="text-gray-800 font-custom">Ticket Price: {event.ticketPrice} EGP</p>
                    <p className="text-gray-800 font-custom">Number of Tickets Left: {event.numberofTicketsLeft}</p>
                    <p className="text-gray-800 font-custom">Number of Participants Submitted: {event.numberofParticipantsSubmitted}</p>
                  </div>

                  <button
                    onClick={() => handleBookTicket(event.eventId)}
                    className="mt-4 w-full bg-purple-600 hover:bg-purple-700 text-white font-bold py-2 px-4 rounded-xl transition"
                  >
                    احجز تذكرتك
                  </button>
                </div>
              );
            })}
          </div>
        ) : (
          <p className="text-white text-xl font-custom text-center mt-6">لا توجد فعاليات حالياً.</p>
        )}
      </div>
    </div>
  );
}

export default HomePage;







